import {useEffect, useState} from 'react';
import {LoadingDiv} from '@components/LoadingDiv'
import { useLocation,useSearchParams,useNavigate} from 'react-router-dom';
import {SGERI_ORG_SYNONYM} from '@constants';
import util from '@utils/utils'
import {ChevronDown, ChevronRight} from 'react-feather'
import { POLICY_EMPTY_FILTERED_TAGS } from '@constants';
import  {Button}  from '../../../../components/UI/button.jsx';
import  {Input}  from '../../../../components/UI/input.jsx';
import  {Label}  from '../../../../components/UI/label.jsx';
import { Calendar, ChevronUp } from 'lucide-react';
import useThemeAction from '../../hooks/useThemeAction';
import { useRef } from 'react';
import { useConfig } from '../../../../contexts/ConfigContext';

// 机构路径映射表：将机构名称映射到完整的层级路径
const ORG_PATH_MAPPING = {
    '发改委': '国务院/国家发展和改革委员会',
    '能源局': '国务院/国家发展和改革委员会/国家能源局',
    '工信部': '国务院/工业和信息化部',
    '国资委': '国务院/国务院国有资产监督管理委员会',
    '国务院': '国务院',
    '财政部': '国务院/财政部',
    '教育部': '国务院/教育部',
    '海关总署': '国务院/海关总署',
    '国家数据局': '国务院/国家发展和改革委员会/国家数据局',
    '深圳市': '广东省/深圳市',
    '香港贸易发展局': '香港特别行政区/香港贸易发展局',
};

// 获取机构的完整层级路径
const getOrgFullPath = (orgName) => {
    return ORG_PATH_MAPPING[orgName] || orgName;
};

// Helper function to format date for display (YYYY/MM/DD)
const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}/${month}/${day}`;
};

// Helper function to convert display format back to YYYY-MM-DD for storage
const parseDisplayDate = (displayDate) => {
    if (!displayDate) return '';
    const parts = displayDate.split('/');
    if (parts.length !== 3) return '';
    
    const [year, month, day] = parts;
    return `${year}-${month}-${day}`;
};

// Helper function to format date for HTML date input (YYYY-MM-DD)
const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
};

// Helper function to validate date range
const validateDateRange = (startDate, endDate) => {
    // 确保有有效的日期进行比较
    if (!startDate || !endDate) {
        return { 
            isValid: true, 
            startDate, 
            endDate, 
            errorMessage: '' 
        };
    }
    
    // 如果开始日期大于结束日期，返回错误状态
    if (startDate > endDate) {
        return {
            isValid: false,
            startDate,
            endDate,
            errorMessage: '结束日期不能早于开始日期'
        };
    }
    
    // 日期范围有效（包括相同日期）
    return {
        isValid: true,
        startDate,
        endDate,
        errorMessage: ''
    };
};



export const LeftMenu = (props) => {
    const { loading,data,setQuery,statisticsData} = props;
    const [searchParams] = useSearchParams();
    const {changeThemeAction, deleteThemeAction} = useThemeAction()
    const { theme } = useConfig();
    // const [input,setInput] =useState()
    const [classCollapsed, setClassCollapsed] = useState(false)         
    const [tagCollapsed, setTagCollapsed] = useState(false)
    // const [fieldCollapsed, setFieldCollapsed] = useState(false)
    const [timeCollapsed, setTimeCollapsed] = useState(false)
    const [provinceCollapsed, setProvinceCollapsed] = useState(false)
    // 政策层级大类折叠状态
    const [centralCollapsed, setCentralCollapsed] = useState(false)
    const [localCollapsed, setLocalCollapsed] = useState(true)

    const [tags, setTags] = useState()
    // 快捷选择选中状态
    const [quickSelect, setQuickSelect] = useState('')
    
    // 日期输入框的引用
    const startDateRef = useRef(null)
    const endDateRef = useRef(null)
    
    // 打开日期选择器的函数 - 兼容所有浏览器
    const openDatePicker = (inputRef) => {
        if (!inputRef.current) return
        
        // 方案1：现代浏览器的 showPicker API
        try {
            if (typeof inputRef.current.showPicker === 'function') {
                inputRef.current.showPicker()
                return
            }
        } catch (error) {
            console.warn('showPicker failed:', error)
        }
        
        // 方案2：Firefox 和部分浏览器 - 临时恢复原生样式
        try {
            // 保存当前样式
            const originalWebkitAppearance = inputRef.current.style.webkitAppearance
            const originalMozAppearance = inputRef.current.style.MozAppearance
            
            // 临时恢复原生样式
            inputRef.current.style.webkitAppearance = 'auto'
            inputRef.current.style.MozAppearance = 'auto'
            
            // 临时显示原生日历图标
            const style = document.createElement('style')
            style.id = 'temp-date-picker-style'
            style.textContent = `
                input[type="date"]::-webkit-calendar-picker-indicator {
                    display: block !important;
                    opacity: 0 !important;
                    position: absolute !important;
                    right: 0 !important;
                    top: 0 !important;
                    width: 100% !important;
                    height: 100% !important;
                    cursor: pointer !important;
                }
            `
            document.head.appendChild(style)
            
            // 聚焦并点击
            inputRef.current.focus()
            inputRef.current.click()
            
            // 50ms 后恢复所有样式
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.style.webkitAppearance = originalWebkitAppearance
                    inputRef.current.style.MozAppearance = originalMozAppearance
                }
                const tempStyle = document.getElementById('temp-date-picker-style')
                if (tempStyle) {
                    document.head.removeChild(tempStyle)
                }
            }, 50)
            
            return
        } catch (error) {
            console.warn('Firefox method failed:', error)
        }
        
        // 方案3：老版本 Chrome/Safari - 键盘触发
        try {
            inputRef.current.focus()
            
            // 模拟按下空格键或回车键来打开日期选择器
            const keydownEvent = new KeyboardEvent('keydown', {
                key: ' ',
                code: 'Space',
                keyCode: 32,
                bubbles: true,
                cancelable: true
            })
            inputRef.current.dispatchEvent(keydownEvent)
            
            // 如果空格键不行，尝试回车键
            setTimeout(() => {
                const enterEvent = new KeyboardEvent('keydown', {
                    key: 'Enter',
                    code: 'Enter', 
                    keyCode: 13,
                    bubbles: true,
                    cancelable: true
                })
                inputRef.current.dispatchEvent(enterEvent)
            }, 10)
            
            return
        } catch (error) {
            console.warn('Keyboard method failed:', error)
        }
        
        // 方案4：最终降级 - 完全显示原生控件
        try {
            // 创建一个临时的原生日期输入框
            const tempInput = document.createElement('input')
            tempInput.type = 'date'
            tempInput.value = inputRef.current.value
            tempInput.style.position = 'absolute'
            tempInput.style.left = '-9999px'
            tempInput.style.opacity = '0'
            
            document.body.appendChild(tempInput)
            
            tempInput.focus()
            tempInput.click()
            
            // 当用户选择日期后，同步到原输入框
            tempInput.addEventListener('change', () => {
                if (inputRef.current) {
                    inputRef.current.value = tempInput.value
                    inputRef.current.dispatchEvent(new Event('change', { bubbles: true }))
                }
                document.body.removeChild(tempInput)
            })
            
            // 5秒后清理临时元素（防止内存泄漏）
            setTimeout(() => {
                if (document.body.contains(tempInput)) {
                    document.body.removeChild(tempInput)
                }
            }, 5000)
            
        } catch (finalError) {
            console.warn('All date picker methods failed:', finalError)
            // 最后的最后：直接让用户手动输入
            alert('请手动输入日期格式：YYYY-MM-DD（例如：2024-01-15）')
        }
    }
    useEffect(()=>{
        let _tags = {...(POLICY_EMPTY_FILTERED_TAGS || {})}
        
        const searchKeyword = searchParams.get('k')
        const orgParam = searchParams.get('org')
        const tabParam = searchParams.get('tab')
        
        if(searchKeyword){
            // 有关键词搜索时，根据 tab 参数设置 large_policy_class_list（tab 优先级大于机构筛选）
            if (tabParam === 'pure_policy' || !tabParam) {
                _tags.large_policy_class_list = ['政策文件', '政策法规', '规章制度', '公示公告', '行业政策'];
            } else if (tabParam === 'interpretation') {
                _tags.large_policy_class_list = ['政策解读'];
            } else if (tabParam === 'important_speech') {
                _tags.large_policy_class_list = ['重要讲话'];
            }
            
            // 合并现有的 tags 状态
            _tags = { ..._tags, ...(tags || {}) }
            
            // 如果有机构参数，设置对应的政策层级（使用完整的层级路径）
            if(orgParam){
                // 使用映射表获取完整的层级路径
                const fullPath = getOrgFullPath(orgParam);
                _tags.province_list = [fullPath];
            }
        } else if(orgParam){
            // 只有在没有搜索关键词时才设置机构筛选
            // 使用映射表获取完整的层级路径
            const fullPath = getOrgFullPath(orgParam);
            _tags.province_list = [fullPath];
            
            // 根据 tab 参数设置 large_policy_class_list
            if (tabParam === 'pure_policy' || !tabParam) {
                _tags.large_policy_class_list = ['政策文件', '政策法规', '规章制度', '公示公告', '行业政策'];
            } else if (tabParam === 'interpretation') {
                _tags.large_policy_class_list = ['政策解读'];
            } else if (tabParam === 'important_speech') {
                _tags.large_policy_class_list = ['重要讲话'];
            }
            
            _tags = { ..._tags, ...(tags || {}) }
        } else {
            // 没有关键词和org参数，保持原逻辑
            _tags = { ..._tags, ...(tags || {}) }
        }
        setTags(_tags)
        setQuery({filter_tags:_tags})
    },[searchParams])

    // 优化新版浏览器中的日历图标样式和防止横向滚动条
    useEffect(() => {
        const style = document.createElement('style');
        style.id = 'date-picker-style-enhancement';
        style.textContent = `
            /* 方案一：直接隐藏横向滚动条，兼容主流浏览器 */
            .drawer-side {
                overflow-x: hidden !important;
            }
            .drawer-side::-webkit-scrollbar {
                height: 0 !important;
            }
            .drawer-side {
                scrollbar-width: none !important;
            }
            
            /* 禁用日期输入框的键盘输入，强制只能点击选择 */
            #start-date,
            #end-date {
                -webkit-user-select: none !important;
                -moz-user-select: none !important;
                -ms-user-select: none !important;
                user-select: none !important;
                -webkit-touch-callout: none !important;
                -webkit-tap-highlight-color: transparent !important;
            }
            
            /* 禁用输入框的键盘事件 */
            #start-date:focus,
            #end-date:focus {
                outline: none !important;
                -webkit-user-select: none !important;
                -moz-user-select: none !important;
                -ms-user-select: none !important;
                user-select: none !important;
            }
            
            /* 确保日历图标始终可见且可点击 */
            #start-date::-webkit-calendar-picker-indicator,
            #end-date::-webkit-calendar-picker-indicator {
                position: absolute !important;
                right: 8px !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                width: 20px !important;
                height: 20px !important;
                cursor: pointer !important;
                opacity: 1 !important;
                z-index: 10 !important;
            }
            
            /* Firefox 日历图标 */
            #start-date::-moz-calendar-picker-indicator,
            #end-date::-moz-calendar-picker-indicator {
                position: absolute !important;
                right: 8px !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                width: 20px !important;
                height: 20px !important;
                cursor: pointer !important;
                opacity: 1 !important;
                z-index: 10 !important;
            }
            
            /* 确保所有文本都能正确截断 */
            .label-text {
                word-break: break-word !important;
                overflow-wrap: break-word !important;
            }
            
            /* 确保按钮不会超出容器 */
            .drawer-side button {
                max-width: 100% !important;
                box-sizing: border-box !important;
            }
            
            /* 确保网格布局不会溢出 */
            .drawer-side .grid {
                max-width: 100% !important;
                overflow: hidden !important;
            }
            
            /* 针对Tailwind的flex布局 */
            .drawer-side .flex {
                max-width: 100% !important;
                overflow: hidden !important;
            }
            /* 针对新版浏览器优化日历图标位置 */
            #start-date::-webkit-calendar-picker-indicator,
            #end-date::-webkit-calendar-picker-indicator {
                position: absolute !important;
                right: 8px !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                width: 16px !important;
                height: 16px !important;
                cursor: pointer !important;
                opacity: 0.7 !important;
            }
            
            #start-date::-webkit-calendar-picker-indicator:hover,
            #end-date::-webkit-calendar-picker-indicator:hover {
                opacity: 1 !important;
            }
            
            /* 确保输入框有足够的右边距给图标，同时保持文本居中 */
            #start-date,
            #end-date {
                padding-right: 32px !important;
                position: relative !important;
                text-align: center !important;
            }
        `;
        document.head.appendChild(style);
        
        return () => {
            const existingStyle = document.getElementById('date-picker-style-enhancement');
            if (existingStyle) {
                document.head.removeChild(existingStyle);
            }
        };
    }, []);

    const selectTagAction =(type,item) => {
        let _tags = {...(tags || {})}; // 保证tags永远是对象
        let typeTags = Array.isArray(_tags[type]) ? _tags[type] : [];
        if(typeTags?.some(i=>i === item.name)){
            typeTags = [...typeTags.filter(i=>i !== item.name)]
        }else{
            typeTags = [...typeTags, item.name]
        }
        _tags[type] = typeTags
        setTags(_tags)
        
        // 根据当前 tab 参数设置 large_policy_class_list，确保 tab 优先级大于机构筛选
        let params_tags = {...(POLICY_EMPTY_FILTERED_TAGS || {}), ..._tags}
        
        const tabParam = searchParams.get('tab')
        const searchKeyword = searchParams.get('k')
        
        if (searchKeyword) {
            // 根据 tab 参数设置 large_policy_class_list
            if (tabParam === 'pure_policy' || !tabParam) {
                params_tags.large_policy_class_list = ['政策文件', '政策法规', '规章制度', '公示公告', '行业政策'];
            } else if (tabParam === 'interpretation') {
                params_tags.large_policy_class_list = ['政策解读'];
            } else if (tabParam === 'important_speech') {
                params_tags.large_policy_class_list = ['重要讲话'];
            }
        }
        
        // 统一 time_range 格式
        if (params_tags.time_range && params_tags.time_range[0] && params_tags.time_range[1]) {
            params_tags.time_range = [{ start_time: params_tags.time_range[0], end_time: params_tags.time_range[1] }];
        } else {
            delete params_tags.time_range;
        }
        setQuery({filter_tags:params_tags})
    }

    // 政策层级分类函数
    // 辅助函数：处理层级路径，只取最后一个机构名称
    const getLastOrgName = (name) => {
        if (!name) return '';
        // 如果包含 "/"，说明是层级路径，取最后一个
        if (name.includes('/')) {
            const parts = name.split('/');
            return parts[parts.length - 1];
        }
        return name;
    }

    // 层级项目折叠状态
    const [hierarchyCollapsed, setHierarchyCollapsed] = useState({})

    // 渲染层级项目，支持折叠展开
    const renderHierarchicalItem = (item, index, categoryType) => { 
        const name = item?.name || ''; 
        
        // 如果是合并后的父节点 
        if (item.isMergedParent) { 
            const itemKey = `${categoryType}_${name}_merged`; 
            const isCollapsed = hierarchyCollapsed[itemKey] || false; 
            
            return ( 
                <div key={itemKey}> 
                    {/* 合并后的父节点（国务院） */} 
                    <div className="form-control"> 
                        <label className="label cursor-pointer py-1"> 
                            <div className='flex items-center gap-4 min-w-0 max-w-full'> 
                                <input 
                                    type="checkbox" 
                                    className="checkbox checkbox-sm flex-shrink-0" 
                                    // 父节点选中状态：所有子节点都选中才选中 
                                    checked={item.children.every(child => tags?.province_list?.includes(`${item.name}/${child.name}`))} 
                                    // 点击父节点时选中/取消所有子节点 
                                    onChange={() => { 
                                        const childNames = item.children.map(child => `${item.name}/${child.name}`); 
                                        selectCategoryAction(childNames.map(name => ({name}))); 
                                    }} 
                                /> 
                                <span 
                                    className="cursor-pointer select-none flex items-center gap-1" 
                                    onClick={() => setHierarchyCollapsed(prev => ({ ...prev, [itemKey]: !prev[itemKey] }))} 
                                > 
                                    {isCollapsed ? <ChevronRight size={14} /> : <ChevronDown size={14} />} 
                                    <span className="label-text text-sm truncate min-w-0 max-w-full">{name}</span> 
                                </span> 
                            </div> 
                        </label> 
                    </div> 
                    
                    {/* 子节点列表（工信部、发改委等） */} 
                    {!isCollapsed && ( 
                        <div className="ml-4 space-y-1"> 
                            {item.children.map((child, childIndex) => ( 
                                <div className="form-control" key={`${itemKey}_child_${childIndex}`}> 
                                    <label className="label cursor-pointer py-1"> 
                                        <div className='flex items-center gap-4 min-w-0 max-w-full'> 
                                            <input 
                                                type="checkbox" 
                                                className="checkbox checkbox-sm flex-shrink-0" 
                                                checked={tags?.province_list?.includes(`${item.name}/${child.name}`)} 
                                                onChange={() => selectTagAction('province_list', {name: `${item.name}/${child.name}`})} 
                                            /> 
                                            <span className="label-text text-sm truncate min-w-0 max-w-full">{child.name}</span> 
                                        </div> 
                                    </label> 
                                </div> 
                            ))} 
                        </div> 
                    )} 
                </div> 
            ); 
        } 
        
        // 以下是原有非合并项的渲染逻辑（保持不变） 
        if (!name.includes('/')) { 
            return ( 
                <div className="form-control" key={`${categoryType}_${index}`}> 
                    <label className="label cursor-pointer py-1"> 
                        <div className='flex items-center gap-4 min-w-0 max-w-full'> 
                            <input 
                                type="checkbox" 
                                className="checkbox checkbox-sm flex-shrink-0" 
                                checked={tags?.province_list?.includes(name)} 
                                onChange={() => selectTagAction('province_list', item)} 
                            /> 
                            <span className="label-text text-sm truncate min-w-0 max-w-full">{name}</span> 
                        </div> 
                    </label> 
                </div> 
            ); 
        } 
        
        // 原有层级路径处理逻辑（保持不变） 
        const parts = name.split('/'); 
        const firstLevel = parts[0]; 
        const restLevels = parts.slice(1); 
        const itemKey = `${categoryType}_${firstLevel}_${index}`; 
        const isCollapsed = hierarchyCollapsed[itemKey] || false; 
        
        return ( 
            <div key={`${categoryType}_${index}`}> 
                {/* 第一级 - 带折叠箭头和复选框 */} 
                <div className="form-control"> 
                    <label className="label cursor-pointer py-1"> 
                        <div className='flex items-center gap-4 min-w-0 max-w-full'> 
                            <input 
                                type="checkbox" 
                                className="checkbox checkbox-sm flex-shrink-0" 
                                checked={tags?.province_list?.includes(name)} 
                                onChange={() => selectTagAction('province_list', item)} 
                            /> 
                            <span 
                                className="cursor-pointer select-none flex items-center gap-1" 
                                onClick={() => setHierarchyCollapsed(prev => ({ ...prev, [itemKey]: !prev[itemKey] }))} 
                            > 
                                {isCollapsed ? <ChevronRight size={14} /> : <ChevronDown size={14} />} 
                                <span className="label-text text-sm truncate min-w-0 max-w-full">{firstLevel}</span> 
                            </span> 
                        </div> 
                    </label> 
                </div> 
                
                {/* 子级 - 只在展开时显示，包含复选框 */} 
                {!isCollapsed && restLevels.length > 0 && ( 
                    <div className="ml-4 space-y-1"> 
                        {restLevels.map((level, levelIndex) => ( 
                            <div className="form-control" key={`${itemKey}_${levelIndex}`}> 
                                <label className="label cursor-pointer py-1"> 
                                    <div className='flex items-center gap-4 min-w-0 max-w-full'> 
                                        <input 
                                            type="checkbox" 
                                            className="checkbox checkbox-sm flex-shrink-0" 
                                            checked={tags?.province_list?.includes(name)} 
                                            onChange={() => selectTagAction('province_list', item)} 
                                        /> 
                                        <span className="label-text text-sm truncate min-w-0 max-w-full"> 
                                            {level} 
                                        </span> 
                                    </div> 
                                </label> 
                            </div> 
                        ))} 
                    </div> 
                )} 
            </div> 
        ); 
    }

    // 递归渲染节点组件
    const renderTreeNode = (node, categoryType, parentPath = '') => {
        const currentPath = parentPath ? `${parentPath}/${node.name}` : node.name;
        const itemKey = `node_${categoryType}_${currentPath}`;
        const isCollapsed = hierarchyCollapsed[itemKey] || false;
        // ✅ 修复：添加空值检查
        const hasChildren = node._children && typeof node._children === 'object' && Object.keys(node._children).length > 0;
        const isSelected = node._item ? tags?.province_list?.includes(node._fullPath) : false;
        
        // ✅ 修复：在 hasSelectedChildren 中添加空值检查
        const hasSelectedChildren = () => {
            const checkChildren = (childrenObj) => {
                if (!childrenObj || typeof childrenObj !== 'object') {
                    return false;
                }
                return Object.values(childrenObj).some(child => {
                    if (child._item && tags?.province_list?.includes(child._fullPath)) {
                        return true;
                    }
                    return child._children ? checkChildren(child._children) : false;
                });
            };
            return node._children ? checkChildren(node._children) : false;
        };

        return (
            <div key={itemKey}>
                {/* 节点行（保持原样式类） */}
                <div className="form-control">
                    <label className="label cursor-pointer py-1">
                        <div className='flex items-center gap-4 min-w-0 max-w-full'>
                            {/* 复选框（保留原样式） */}
                            <input
                                type="checkbox"
                                className="checkbox checkbox-sm flex-shrink-0"
                                checked={isSelected || hasSelectedChildren()}
                                onChange={() => {
                                    if (node._item) {
                                        // 如果是叶子节点，直接切换选中状态
                                        selectTagAction('province_list', { name: node._fullPath });
                                    } else {
                                        // ✅ 修复：在 collectChildren 中添加空值检查
                                        const collectChildren = (childNode) => {
                                            if (childNode._item) {
                                                childItems.push(childNode._fullPath);
                                            }
                                            if (childNode._children && typeof childNode._children === 'object') {
                                                Object.values(childNode._children).forEach(child => {
                                                    collectChildren(child);
                                                });
                                            }
                                        };
                                        const childItems = [];
                                        // ✅ 修复：调用 collectChildren 前添加空值检查
                                        if (node._children && typeof node._children === 'object') {
                                            Object.values(node._children).forEach(child => {
                                                collectChildren(child);
                                            });
                                        }
                                        
                                        // 检查是否所有子节点都已选中
                                        const currentSelected = tags?.province_list || [];
                                        const allChildrenSelected = childItems.every(childPath => 
                                            currentSelected.includes(childPath)
                                        );
                                        
                                        let _tags = {...tags};
                                        let newSelected = [...currentSelected];
                                        
                                        if (allChildrenSelected) {
                                            // 如果所有子节点都已选中，则取消选中所有子节点
                                            newSelected = newSelected.filter(name => !childItems.includes(name));
                                        } else {
                                            // 如果不是所有子节点都选中，则选中所有子节点
                                            childItems.forEach(childPath => {
                                                if (!newSelected.includes(childPath)) {
                                                    newSelected.push(childPath);
                                                }
                                            });
                                        }
                                        
                                        _tags.province_list = newSelected;
                                        setTags(_tags);
                                        
                                        // 更新查询参数
                                        let params_tags = {..._tags};
                                        const tabParam = searchParams.get('tab');
                                        const searchKeyword = searchParams.get('k');
                                        
                                        if (searchKeyword) {
                                            if (tabParam === 'pure_policy' || !tabParam) {
                                                params_tags.large_policy_class_list = ['政策文件', '政策法规', '规章制度', '公示公告', '行业政策'];
                                            } else if (tabParam === 'interpretation') {
                                                params_tags.large_policy_class_list = ['政策解读'];
                                            } else if (tabParam === 'important_speech') {
                                                params_tags.large_policy_class_list = ['重要讲话'];
                                            }
                                        }
                                        
                                        if (params_tags.time_range && params_tags.time_range[0] && params_tags.time_range[1]) {
                                            params_tags.time_range = [{ start_time: params_tags.time_range[0], end_time: params_tags.time_range[1] }];
                                        } else {
                                            delete params_tags.time_range;
                                        }
                                        setQuery({ filter_tags: params_tags });
                                    }
                                }}
                            />
                            {/* 名称+折叠箭头（保持原样式） */}
                            <span 
                                className="cursor-pointer select-none flex items-center gap-1"
                                onClick={() => hasChildren && setHierarchyCollapsed(prev => ({ ...prev, [itemKey]: !prev[itemKey] }))}
                            >
                                {hasChildren && (isCollapsed ? <ChevronRight size={14} /> : <ChevronDown size={14} />)}
                                <span className="label-text text-sm truncate min-w-0 max-w-full">{node.name}</span>
                            </span>
                        </div>
                    </label>
                </div>
                {/* 递归渲染子节点（保持原缩进样式） */}
                {!isCollapsed && hasChildren && (
                    <div className="ml-4 space-y-1">
                        {Object.entries(node._children).map(([childKey, childNode]) =>
                            renderTreeNode({ name: childKey, ...childNode }, categoryType, currentPath)
                        )}
                    </div>
                )}
            </div>
        );
    };

    // 构建多层级树形结构
    const buildHierarchyTree = (items) => {
        const tree = {};
        items.forEach(item => {
            const name = item.name || '';
            const parts = name.split('/');
            let currentNode = tree;
            parts.forEach((part, index) => {
                if (!currentNode[part]) {
                    currentNode[part] = {
                        _children: {},
                        _item: index === parts.length - 1 ? item : null,
                        _fullPath: parts.slice(0, index + 1).join('/')
                    };
                }
                currentNode = currentNode[part]._children;
            });
        });
        return tree;
    };

    const categorizeProvinceData = (provinceList) => {
        const categories = {
            important_speech: [],
            central: [],
            local: []
        };
        
        if (!provinceList?.length) return categories;

        // 筛选中央机构
        const centralItems = provinceList.filter(item => {
            const name = item.name || '';
            return name.includes('国务院') || name.includes('中央') || name.includes('国家');
        });

        // 构建树形结构并转换为数组
        const centralTree = buildHierarchyTree(centralItems);
        const treeToArray = (node) => Object.entries(node).map(([key, val]) => ({
            name: key,
            _children: val._children,
            _item: val._item,
            _fullPath: val._fullPath
        }));
        categories.central = treeToArray(centralTree);

        // 其他分类逻辑保持不变
        provinceList.forEach(item => {
            const name = item.name || '';
            if (name === '重要讲话数据') {
                categories.important_speech.push(item);
            } else if (!centralItems.includes(item)) {
                categories.local.push(item);
            }
        });
        
        return categories;
    }

    // 选择整个分类的所有项
    const selectCategoryAction = (categoryItems) => {
        let _tags = {...tags}
        const categoryNames = categoryItems.map(item => item.name)
        const currentSelected = _tags.province_list || []
        
        // 检查是否所有类别项都已选中
        const allSelected = categoryNames.every(name => currentSelected.includes(name))
        
        let newSelected
        if (allSelected) {
            // 如果全部已选中，则取消选中
            newSelected = currentSelected.filter(name => !categoryNames.includes(name))
        } else {
            // 如果没有全部选中，则选中所有
            newSelected = [...new Set([...currentSelected, ...categoryNames])]
        }
        
        _tags.province_list = newSelected
        setTags(_tags)
        
        // 根据当前 tab 参数设置 large_policy_class_list，确保 tab 优先级大于机构筛选
        let params_tags = {..._tags}
        
        const tabParam = searchParams.get('tab')
        const searchKeyword = searchParams.get('k')
        
        if (searchKeyword) {
            // 根据 tab 参数设置 large_policy_class_list
            if (tabParam === 'pure_policy' || !tabParam) {
                params_tags.large_policy_class_list = ['政策文件', '政策法规', '规章制度', '公示公告', '行业政策'];
            } else if (tabParam === 'interpretation') {
                params_tags.large_policy_class_list = ['政策解读'];
            } else if (tabParam === 'important_speech') {
                params_tags.large_policy_class_list = ['重要讲话'];
            }
        }
        
        // 统一 time_range 格式
        if (params_tags.time_range && params_tags.time_range[0] && params_tags.time_range[1]) {
            params_tags.time_range = [{ start_time: params_tags.time_range[0], end_time: params_tags.time_range[1] }];
        } else {
            delete params_tags.time_range;
        }
        setQuery({filter_tags:params_tags})
    }

    // 首次有数据时缓存全部层级
    useEffect(() => {
        if (statisticsData?.total_province_list && statisticsData.total_province_list.length > 0 && allProvinceList.length === 0) {
            setAllProvinceList(statisticsData.total_province_list);
        }
    }, [statisticsData]);

    const [allProvinceList, setAllProvinceList] = useState([]); // 新增：缓存全部层级

    return (
        <>
        <div className={`drawer lg:drawer-open relative w-auto`}>
            <input id="leftMenuDrawer" type="checkbox" className="drawer-toggle" />
            <div className='lg:hidden'>
                <label htmlFor="leftMenuDrawer" className="z-20 bg-base-100 btn drawer-button lg:hidden fixed left-4 bottom-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z" />
                    </svg>
                </label>
            </div> 
            <div className="drawer-side z-20 flex flex-col mt-2.5">
                <label htmlFor="leftMenuDrawer" aria-label="close sidebar" className="drawer-overlay"></label> 
                <div className={`p-4 lg:p-0 bg-base-100 lg:bg-transparent lg:rounded-bl lg:rounded-tl z-50 relative w-80 2xl:w-88 3xl:w-96 flex-1 max-w-[320px] 2xl:max-w-[352px] 3xl:max-w-[384px]`}>
                    <div className='overflow-x-hidden flex flex-col gap-y-2 w-full max-w-full'>

                        {/* 政策层级*/}
                        <div className={`collapse collapse-arrow ${provinceCollapsed ? 'collapse-close' : 'collapse-open'}`} >
                            <input type="checkbox" className='min-h-[2.5rem]' checked={!provinceCollapsed} onChange={()=>setProvinceCollapsed(!provinceCollapsed)}/>
                            <div className="collapse-title bg-primary text-base-100 min-h-[2.5rem] p-3">
                                政策层级
                            </div>
                            <div className={`collapse-content bg-base-100 border pt-2 max-h-[300px] overflow-auto scrollbar-auto scrollbar-hide`}>
                            {
                                !statisticsData && data?.length ===0 && loading ? <LoadingDiv/> : (allProvinceList.length === 0 && (statisticsData?.total_province_list ?? []).length === 0) ? 
                                '暂无内容' :
                                (() => {
                                    // 渲染时始终用allProvinceList分组，数量和选中状态用最新数据
                                    const baseList = allProvinceList.length > 0 ? allProvinceList : (statisticsData?.total_province_list ?? []);
                                    const categorizedData = categorizeProvinceData(baseList);
                                    return (
                                        <div className="space-y-2">
                                            {/* 重要讲话数据 */}
                                            {categorizedData.important_speech.length > 0 && (
                                                <div className="space-y-1">
                                                    {categorizedData.important_speech.map((item, index) => (
                                                <div className="form-control" key={`important_${index}`}>
                                                    <label className="label cursor-pointer py-1">
                                                        <div className='flex items-center gap-4 min-w-0 max-w-full'>
                                                            <input 
                                                                type="checkbox" 
                                                                className="checkbox flex-shrink-0" 
                                                                checked={tags?.province_list?.includes(item?.name)} 
                                                                onChange={() => selectTagAction('province_list', item)}
                                                            />
                                                            <span className="label-text font-semibold truncate min-w-0 max-w-full">{getLastOrgName(item?.name)}</span>
                                                        </div>
                                                        {/* <span className="label-text">({item?.number})</span> */}
                                                    </label>
                                                </div>
                                            ))}
                                                </div>
                                            )}

                                            {/* 中央 */}
                                            {categorizedData.central.length > 0 && (
                                                <div className="pl-2">
                                                    <div className="form-control">
                                                        <div className="flex items-center justify-between py-1">
                                                            <div className='flex items-center gap-2'>
                                                                <input 
                                                                    type="checkbox" 
                                                                    className="checkbox" 
                                                                    checked={categorizedData.central.every(item => 
                                                                        tags?.province_list?.includes(item._fullPath)
                                                                    )}
                                                                    onChange={() => selectCategoryAction(categorizedData.central)}
                                                                />
                                                                <span 
                                                                    className="label-text font-semibold cursor-pointer select-none flex items-center gap-1" 
                                                                    onClick={() => setCentralCollapsed(!centralCollapsed)}
                                                                >
                                                                    {centralCollapsed ? <ChevronRight size={16} /> : <ChevronDown size={16} />}
                                                                    中央
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* 递归渲染多层级节点 */}
                                                    {!centralCollapsed && (
                                                        <div className="ml-4 space-y-1">
                                                            {categorizedData.central.map(node =>
                                                                renderTreeNode(node, 'central')
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* 地方 */}
                                            {categorizedData.local.length > 0 && (
                                                <div className="pl-2">
                                                    <div className="form-control">
                                                        <div className="flex items-center justify-between py-1">
                                                            <div className='flex items-center gap-2'>
                                                                <input 
                                                                    type="checkbox" 
                                                                    className="checkbox" 
                                                                    checked={categorizedData.local.every(item => tags?.province_list?.includes(item?.name))}
                                                                    onChange={() => selectCategoryAction(categorizedData.local)}
                                                                />
                                                                <span 
                                                                    className="label-text font-semibold cursor-pointer select-none flex items-center gap-1" 
                                                                    onClick={() => setLocalCollapsed(!localCollapsed)}
                                                                >
                                                                    {localCollapsed ? <ChevronRight size={16} /> : <ChevronDown size={16} />}
                                                                    地方
                                                                </span>
                                                            </div>
                                                            {/* <span className="label-text">({categorizedData.local.reduce((sum, item) => sum + (item?.number || 0), 0)})</span> */}
                                                        </div>
                                                    </div>
                                                    {!localCollapsed && (
                                        <div className="ml-4 space-y-1">
                                            {categorizedData.local.map((item, index) => 
                                                renderHierarchicalItem(item, index, 'local')
                                            )}
                                        </div>
                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )
                                })()
                            }
                            </div>
                        </div>


                        {/* 所属分类 */}
                        <div className={`collapse collapse-arrow ${classCollapsed ? 'collapse-close' : 'collapse-open'}`} >
                            <input type="checkbox" className='min-h-[2.5rem]' onClick={()=>setClassCollapsed(!classCollapsed)}/>
                            <div
                                className="collapse-title bg-primary text-base-100 min-h-[2.5rem] p-3">
                                所属分类
                            </div>
                            <div className={`collapse-content  bg-base-100 border pt-2 max-h-[300px] overflow-auto scrollbar-auto scrollbar-hide`}>
                            {
                                    !statisticsData && data?.length ===0 && loading ? <LoadingDiv/> : (statisticsData?.total_large_policy_class_list ?? [])?.length === 0 ? '暂无内容' :
                                    <>
                                        {
                                            statisticsData?.total_large_policy_class_list?.map((item,index)=>
                                                <div className="form-control" key={index}>
                                                    <label className="label cursor-pointer py-1">
                                                        <div className='flex items-center gap-4 min-w-0 max-w-full'>
                                                        <input type="checkbox" className="checkbox flex-shrink-0" checked={tags?.large_policy_class_list?.includes(item?.name)} onClick={()=>selectTagAction('large_policy_class_list',item)}/>
                                                        <span className="label-text truncate min-w-0 max-w-full">{item?.name}</span>

                                                        </div>
                                                        {/* <span className="label-text">({item?.number})</span> */}
                                                    </label>
                                                </div>
                                            )
                                        }
                                    </>
                                }
                            </div>
                        </div>

                        {/* 时间 */}
                        <div className={`collapse collapse-arrow ${timeCollapsed ? 'collapse-close' : 'collapse-open'}`} >
                            <input type="checkbox" className='min-h-[2.5rem]' onClick={()=>setTimeCollapsed(!timeCollapsed)}/>
                            <div className="collapse-title bg-primary text-base-100  min-h-[2.5rem] p-3 flex items-center justify-between cursor-pointer" onClick={()=>setTimeCollapsed(!timeCollapsed)}>
                                <span>时间</span>
                            </div>
                            {!timeCollapsed && (
                            <div className="collapse-content bg-base-100 border pt-2 max-h-[400px] overflow-auto scrollbar-auto scrollbar-hide w-full">
                                <div className="p-1 space-y-2 w-full">
                                    {/* 日期范围 */}
                                    <div className="space-y-1">
                                        <div className="space-y-2">
                                            <div>
                                                <Label htmlFor="start-date" className="text-sm font-medium text-gray-700 mb-1 block">
                                                    开始日期
                                                </Label>
                                                <div className="cursor-pointer" onClick={() => openDatePicker(startDateRef)}>
                                                    <Input
                                                        ref={startDateRef}
                                                        id="start-date"
                                                        type="date"
                                                        value={formatDateForInput(tags?.time_range?.[0] || '2025-01-01')}
                                                        onChange={e => {
                                                            const newStart = e.target.value;
                                                            const currentEnd = tags?.time_range?.[1] || '';
                                                            
                                                            // 直接设置新的日期范围，不自动校正
                                                            setTags({...tags, time_range: [newStart, currentEnd]});
                                                        }}
                                                        onKeyDown={e => {
                                                            // 禁用键盘输入，只允许点击选择
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                        onKeyPress={e => {
                                                            // 禁用键盘输入
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                        onKeyUp={e => {
                                                            // 禁用键盘输入
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                        className="text-sm w-full cursor-pointer text-center"
                                                        style={{
                                                            WebkitAppearance: 'auto',
                                                            MozAppearance: 'auto'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <Label htmlFor="end-date" className="text-sm font-medium text-gray-700 mb-1 block">
                                                    结束日期
                                                </Label>
                                                <div className="cursor-pointer" onClick={() => openDatePicker(endDateRef)}>
                                                    <Input
                                                        ref={endDateRef}
                                                        id="end-date"
                                                        type="date"
                                                        value={formatDateForInput(tags?.time_range?.[1] || new Date().toISOString().split('T')[0])}
                                                        onChange={e => {
                                                            const newEnd = e.target.value;
                                                            const currentStart = tags?.time_range?.[0] || '';
                                                            
                                                            // 直接设置新的日期范围，不自动校正
                                                            setTags({...tags, time_range: [currentStart, newEnd]});
                                                        }}
                                                        onKeyDown={e => {
                                                            // 禁用键盘输入，只允许点击选择
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                        onKeyPress={e => {
                                                            // 禁用键盘输入
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                        onKeyUp={e => {
                                                            // 禁用键盘输入
                                                            e.preventDefault();
                                                            return false;
                                                        }}
                                                        className="text-sm w-full cursor-pointer text-center"
                                                        style={{
                                                            WebkitAppearance: 'auto',
                                                            MozAppearance: 'auto'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* 快捷选择 */}
                                    <div className="space-y-2 pt-1 border-t border-gray-200 w-full max-w-full">
                                        <Label className="text-sm font-medium text-gray-700">快捷选择</Label>
                                        <div className="grid grid-cols-2 gap-1 w-full max-w-full">
                                            <Button variant="outline" size="sm" className={`text-xs h-8 bg-transparent truncate min-w-0 max-w-full w-full overflow-hidden ${quickSelect==='month' ? 'border-emerald-500' : ''}`} onClick={() => {
                                                const today = new Date();
                                                const start = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
                                                const startStr = start.toISOString().split('T')[0];
                                                const endStr = today.toISOString().split('T')[0];
                                                setTags({...tags, time_range: [startStr, endStr]});
                                                setQuickSelect('month');
                                            }}>近一月</Button>
                                            <Button variant="outline" size="sm" className={`text-xs h-8 bg-transparent truncate min-w-0 max-w-full w-full overflow-hidden ${quickSelect==='threeMonth' ? 'border-emerald-500' : ''}`} onClick={() => {
                                                const today = new Date();
                                                const start = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
                                                const startStr = start.toISOString().split('T')[0];
                                                const endStr = today.toISOString().split('T')[0];
                                                setTags({...tags, time_range: [startStr, endStr]});
                                                setQuickSelect('threeMonth');
                                            }}>近三月</Button>
                                            <Button variant="outline" size="sm" className={`text-xs h-8 bg-transparent truncate min-w-0 max-w-full w-full overflow-hidden ${quickSelect==='year' ? 'border-emerald-500' : ''}`} onClick={() => {
                                                const today = new Date();
                                                const start = new Date(today.getFullYear(), 0, 1);
                                                const startStr = start.toISOString().split('T')[0];
                                                const endStr = today.toISOString().split('T')[0];
                                                setTags({...tags, time_range: [startStr, endStr]});
                                                setQuickSelect('year');
                                            }}>今年</Button>
                                            <Button variant="outline" size="sm" className={`text-xs h-8 bg-transparent truncate min-w-0 max-w-full w-full overflow-hidden ${quickSelect==='lastYear' ? 'border-emerald-500' : ''}`} onClick={() => {
                                                const today = new Date();
                                                const start = new Date(today.getFullYear() - 1, 0, 1);
                                                const end = new Date(today.getFullYear() - 1, 11, 31);
                                                const pad = n => n < 10 ? '0' + n : n;
                                                const startStr = `${start.getFullYear()}-${pad(start.getMonth() + 1)}-${pad(start.getDate())}`;
                                                const endStr = `${end.getFullYear()}-${pad(end.getMonth() + 1)}-${pad(end.getDate())}`;
                                                setTags({...tags, time_range: [startStr, endStr]});
                                                setQuickSelect('lastYear');
                                            }}>去年</Button>
                                        </div>
                                    </div>
                                    {/* 操作按钮 */}
                                    <div className="flex gap-2 pt-2 w-full max-w-full">
                                        <Button variant="outline" size="sm" className="flex-1 h-9 bg-transparent min-w-0 max-w-[50%] overflow-hidden truncate" onClick={() => {
                                            setTags({...tags, time_range: ['', '']});
                                            const filter_tags = { ...tags, time_range: [] };
                                            // delete filter_tags.time_range;
                                            setQuery({ filter_tags });
                                        }}>清空</Button>
                                        <Button size="sm" className="flex-1 h-9 text-white min-w-0 max-w-[50%] overflow-hidden truncate" style={{
                                            backgroundColor: theme.primary,
                                            '--tw-ring-color': theme.primaryHover,
                                        }} onClick={() => {
                                            const [start, end] = tags?.time_range || [];
                                            const filter_tags = { ...tags };
                                            // 只有当用户实际选择了至少一个日期时才添加时间范围过滤
                                            if (start || end) {
                                                const actualStart = start || '2025-01-01';
                                                const actualEnd = end || new Date().toISOString().split('T')[0];
                                                filter_tags.time_range = [{ start_time: actualStart, end_time: actualEnd }];
                                            } else {
                                                // 如果用户没有选择任何日期，不添加时间过滤
                                                delete filter_tags.time_range;
                                            }
                                            setQuery({ filter_tags });
                                        }} disabled={(() => {
                                            const [start, end] = tags?.time_range || [];
                                            // 如果用户选择了至少一个日期，则进行验证
                                            if (start || end) {
                                                const actualStart = start || '2025-01-01';
                                                const actualEnd = end || new Date().toISOString().split('T')[0];
                                                const validation = validateDateRange(actualStart, actualEnd);
                                                return !validation.isValid;
                                            }
                                            // 如果用户没有选择任何日期，可以搜索
                                            return false;
                                        })()}>搜索</Button>
                                    </div>
                                    {/* 当前选择显示 - 只有用户选择了至少一个日期时才显示 */}
                                    {(tags?.time_range?.[0] || tags?.time_range?.[1]) && (
                                        <div className="mt-2 p-2 bg-blue-50 rounded-md border border-emerald-200 w-full max-w-full overflow-hidden">
                                            <div className="text-xs text-emerald-600 w-full max-w-full">
                                                {/* 日期范围错误提示 */}
                                                {(() => {
                                                    const [start, end] = tags?.time_range || [];
                                                    // 只有当用户选择了至少一个日期时才进行验证和显示
                                                    if (start || end) {
                                                        const actualStart = start || '2025-01-01';
                                                        const actualEnd = end || new Date().toISOString().split('T')[0];
                                                        const validation = validateDateRange(actualStart, actualEnd);
                                                        if (!validation.isValid) {
                                                            return (
                                                                <div className="mb-2 text-xs text-red-600">
                                                                    ❌ {validation.errorMessage}
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                    return null;
                                                })()}
                                                <div className="font-medium mb-1">当前选择：</div>
                                                <div className="break-words overflow-hidden text-ellipsis">
                                                    开始：{formatDateForDisplay(tags?.time_range?.[0] || '2025-01-01')}
                                                </div>
                                                <div className="break-words overflow-hidden text-ellipsis">
                                                    结束：{formatDateForDisplay(tags?.time_range?.[1] || new Date().toISOString().split('T')[0])}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            )}
                        </div>


                    </div>
                </div>    
            
            </div>
        </div>
        </>
    )
  }
